<template>
  <div class="btn-desc" style="margin: 0 20px">
    <a-button type="primary" @click="onClickSave">{{ leftTitle }}</a-button>
    <a-button v-if="showRight" @click="onClickCancel">{{ rightTitle }}</a-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    rightTitle: {
      default() {
        return this.$t('actionTitles.delete')
      },
      type: String
    },
    leftTitle: {
      default() {
        return this.$t('actionTitles.save')
      },
      type: String
    },
    showRight: {
      type: Number,
      default: 1,
    }
  },
  // data() {
  //   return {
  //     rightDefault: this.$t('actionTitles.delete'), 
  //     leftDefault: this.$t('actionTitles.save'), 
  //   }
  // },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    onClickSave() {
      this.$emit("onClickSave")
    },
    onClickCancel() {
      this.$emit("onClickCancel")
    }
  },
};
</script>

<style lang="less" scoped>
.btn-desc {
  display: flex;
  justify-content: space-between;
  margin: 0;
  flex: 1;

  button {
    width: calc((100% - 10px) / 2);
  }

  .saveBtn {
    background-color: #7101ad;
    border-color: #7101ad
  }
}</style>
